export default __webpack_public_path__ + "static/media/TerryWalton.3cb27389.jpg";